export const filterProjects = (searchParam, data) => {
  let filteredProjects = data.filter(function (e) {
    return e.techStack.includes(searchParam);
  });

  return filteredProjects;
};
